// src/components/hub/work/MovePickerModal.js
import React from "react";
import { popupBg, popupBorder, popupText, popupSubtext, popupBtn } from "../constants";

const STATUSES = ["todo", "in_progress", "needs_assistance", "done", "canceled"];

const formatStatus = (s) =>
  s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const MovePickerModal = ({ open, taskIds = [], onSelect, onClose }) => {
  if (!open || !taskIds.length) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className={`relative ${popupBg} ${popupBorder} ${popupText} rounded-xl shadow-xl p-6 w-80`}>
        <p className={`text-sm font-semibold ${popupText} mb-3`}>Move to status</p>
        <p className={`text-xs ${popupSubtext} mb-4`}>
          {taskIds.length} item{taskIds.length !== 1 ? "s" : ""} selected
        </p>
        <div className="space-y-2">
          {STATUSES.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => onSelect(s)}
              className={`w-full text-left text-sm ${popupBtn} px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 transition-colors`}
            >
              {formatStatus(s)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MovePickerModal;
